// extracted by mini-css-extract-plugin
export default {"accordion_theme_text":"accordion_accordion_theme_text__vd8Gg","caption":"accordion_caption__ndE8i","icon":"accordion_icon__6T4zQ","iconAlert":"accordion_iconAlert__5Wh4v"};